import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionExclusionPageV2 as SubscriptionV2ExclusionPage } from '../../../components/pages/subscription-v2/subscription-v2-exclusion-page.tsx'

export const Route = createFileRoute('/subscribe-exclusion/$subscriptionId')({
  component: SubscriptionV2ExclusionPage,
})
